/**
 * Gets the current language from the I18n global object
 * @returns The current language code (e.g., 'en', 'es', 'fr')
 */
export default function getCurrentLanguage() {
    // I18n comes from Sprockets and is available on the window object
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
    const { I18n } = window;
    // Default to English if I18n is not available
    if (!I18n) {
        return 'en';
    }
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
        return I18n.locale || 'en';
    }
    catch (error) {
        console.error('Error getting current language:', error);
        return 'en';
    }
}
